import { useState, useEffect } from "react";
import "./LasVegasTicket.css";
import ConventionTicketModel from "../../model/ConventionTicketModel";
import AlertMsg from "../AlertMsg/AlertMsg";
import AlertMsgError from "../AlertMsg/AlertMsgError";
import { useUser } from "../../context/UserContext";
import tiket from "../../Assets/Images/Baners_jpg/ticket.png";

const LasVegasTicket = () => {
    const { userData } = useUser();
    const [hasTicket, setHasTicket] = useState(false);
    const [ticketData, setTicketData] = useState(null);
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    const [fromComision, setFromComision] = useState(0);
    const [fromDividend, setFromDividend] = useState(0);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [visibleError, setVisibleError] = useState(false);
    const [msj, setMsj] = useState("");

    const ticketPrice = 500;

    useEffect(() => {
        if (userData && userData.firebaseKey) {
            checkUserTicket();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData]);

    const checkUserTicket = () => {
        ConventionTicketModel.getUserTicket(userData.firebaseKey, (data) => {
            if (data) {
                setHasTicket(true);
                setTicketData(data);
            } else {
                setHasTicket(false);
                setTicketData(null);
            }
        });
    };

    const openPurchaseModal = () => {
        // Validación adicional de userData
        if (!userData || !userData.firebaseKey) {
            setMsj("User data not available");
            setVisibleError(true);
            return;
        }

        const model = new ConventionTicketModel(userData.firebaseKey, userData);
        const balance = model.checkBalance();

        if (!balance.canPurchase) {
            setMsj(`Insufficient balance. You need ${balance.deficit} USDT more.`);
            setVisibleError(true);
            return;
        }

        // Por defecto, intentar usar primero dividendos
        if (balance.walletDiv >= ticketPrice) {
            setFromDividend(ticketPrice);
            setFromComision(0);
        } else if (balance.walletCom >= ticketPrice) {
            setFromComision(ticketPrice);
            setFromDividend(0);
        } else {
            // Usar ambas wallets
            setFromDividend(balance.walletDiv);
            setFromComision(ticketPrice - balance.walletDiv);
        }

        setShowPurchaseModal(true);
    };

    const handlePurchase = async () => {
        if (fromComision + fromDividend !== ticketPrice) {
            setMsj("Payment amounts must equal 500 USDT");
            setVisibleError(true);
            return;
        }

        setLoading(true);
        try {
            const model = new ConventionTicketModel(userData.firebaseKey, userData);
            await model.purchaseTicket(fromComision, fromDividend);

            setMsj("🎉 Ticket purchased successfully! Welcome to Las Vegas Convention 2026!");
            setVisible(true);
            setShowPurchaseModal(false);
            checkUserTicket();
        } catch (error) {
            console.error("Error purchasing ticket:", error);
            setMsj(error.message || "Error purchasing ticket");
            setVisibleError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleSliderChange = (wallet, value) => {
        const numValue = parseFloat(value);
        
        // Validación de userData
        if (!userData) return;
        
        if (wallet === 'comision') {
            const maxFromCom = Math.min(userData.walletCom || 0, ticketPrice);
            const newFromCom = Math.min(numValue, maxFromCom);
            setFromComision(newFromCom);
            setFromDividend(Math.max(0, ticketPrice - newFromCom));
        } else {
            const maxFromDiv = Math.min(userData.walletDiv || 0, ticketPrice);
            const newFromDiv = Math.min(numValue, maxFromDiv);
            setFromDividend(newFromDiv);
            setFromComision(Math.max(0, ticketPrice - newFromDiv));
        }
    };

    return (
        <div className="las-vegas-ticket">
            <AlertMsg visible={visible} setVisible={setVisible} texto={msj} />
            <AlertMsgError visible={visibleError} setVisible={setVisibleError} texto={msj} />

            {hasTicket ? (
                // Usuario ya tiene ticket
                <div className="ticket-card">
                    <div className="ticket-status">
                        <span className="status-confirmed">✓ Confirmed</span>
                    </div>
                    
                    <img src={tiket} alt="Las Vegas Convention" className="ticket-image" />
                    
                    <div className="ticket-info-minimal">
                        <h3>Las Vegas Convention 2026</h3>
                        <div className="ticket-number">{ticketData.ticketNumber}</div>
                        <div className="ticket-detail">
                            <span>{ticketData.firstName} {ticketData.lastName}</span>
                        </div>
                        <div className="ticket-detail">
                            <span>${ticketData.ticketPrice} USDT</span>
                        </div>
                    </div>
                </div>
            ) : (
                // Usuario no tiene ticket
                <div className="ticket-card">
                    <img src={tiket} alt="Las Vegas Convention" className="ticket-image" />
                    
                    <div className="ticket-info-minimal">
                        <h3>Las Vegas Convention 2026</h3>
                        <div className="price-minimal">$500 USDT</div>
                        
                        <div className="balance-minimal">
                            <div className="balance-line">
                                <span>Commission:</span>
                                <span>${(userData?.walletCom || 0).toFixed(2)}</span>
                            </div>
                            <div className="balance-line">
                                <span>Dividend:</span>
                                <span>${(userData?.walletDiv || 0).toFixed(2)}</span>
                            </div>
                            <div className="balance-line total">
                                <span>Total:</span>
                                <span>${((userData?.walletCom || 0) + (userData?.walletDiv || 0)).toFixed(2)}</span>
                            </div>
                        </div>

                        <button 
                            onClick={openPurchaseModal}
                            className="btn-purchase-minimal"
                            disabled={(userData?.walletCom || 0) + (userData?.walletDiv || 0) < ticketPrice}
                        >
                            Purchase Ticket
                        </button>

                        {(userData?.walletCom || 0) + (userData?.walletDiv || 0) < ticketPrice && (
                            <p className="error-minimal">
                                Insufficient balance
                            </p>
                        )}
                    </div>
                </div>
            )}

            {/* Modal de compra */}
            {showPurchaseModal && userData && (
                <div className="modal-overlay-minimal">
                    <div className="modal-minimal">
                        <button onClick={() => setShowPurchaseModal(false)} className="close-minimal">
                            ×
                        </button>

                        <h3>Payment</h3>

                        <div className="payment-sliders">
                            <div className="slider-group">
                                <label>Commission: ${fromComision.toFixed(2)}</label>
                                <input
                                    type="range"
                                    min="0"
                                    max={Math.min(userData.walletCom || 0, ticketPrice)}
                                    step="1"
                                    value={fromComision}
                                    onChange={(e) => handleSliderChange('comision', e.target.value)}
                                />
                                <small>Available: ${(userData.walletCom || 0).toFixed(2)}</small>
                            </div>

                            <div className="slider-group">
                                <label>Dividend: ${fromDividend.toFixed(2)}</label>
                                <input
                                    type="range"
                                    min="0"
                                    max={Math.min(userData.walletDiv || 0, ticketPrice)}
                                    step="1"
                                    value={fromDividend}
                                    onChange={(e) => handleSliderChange('dividend', e.target.value)}
                                />
                                <small>Available: ${(userData.walletDiv || 0).toFixed(2)}</small>
                            </div>
                            
                            <div className="total-minimal">
                                Total: ${fromComision + fromDividend}
                            </div>

                            {fromComision + fromDividend !== ticketPrice && (
                                <p className="error-minimal">Must equal $500</p>
                            )}
                        </div>

                        <div className="modal-buttons">
                            <button 
                                onClick={() => setShowPurchaseModal(false)}
                                className="btn-secondary-minimal"
                            >
                                Cancel
                            </button>
                            <button 
                                onClick={handlePurchase}
                                className="btn-primary-minimal"
                                disabled={loading || fromComision + fromDividend !== ticketPrice}
                            >
                                {loading ? 'Processing...' : 'Confirm'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LasVegasTicket;
